'use client'
import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'

const navigation = [
  { name: 'Inicio', href: '/' },
  { name: 'Quiénes Somos', href: '/nosotros' },
  { name: 'Servicios', href: '/servicios' },
  { name: 'Productos', href: '/productos' },
  { name: 'Contacto', href: '/contacto' },
]

export default function Example() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <div className="bg-white">
      <header className="absolute inset-x-0 top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100/80">
        <nav aria-label="Global" className="flex items-center justify-between p-4 lg:px-10 max-w-full mx-auto">
          <div className="flex lg:flex-1">
            <Link to="/" className="-m-1.5 p-1.5 flex items-center gap-2">
              <img
                alt="Adrox"
                src="/images/adrox_b.png"
                className="h-9 w-auto"
              />
            </Link>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-[#353E40]"
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-8">
            {navigation.map((item) => (
              item.href.startsWith('#') ? (
                <a key={item.name} href={item.href} className="text-sm font-medium leading-6 text-gray-600 hover:text-[#366D73] transition-colors duration-200">
                  {item.name}
                </a>
              ) : (
                <Link key={item.name} to={item.href} className="text-sm font-medium leading-6 text-gray-600 hover:text-[#366D73] transition-colors duration-200">
                  {item.name}
                </Link>
              )
            ))}
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <a
              href="https://wa.me/+51933534235?text=Hola%20estoy%20interesado%20en%20adrox"
              className="rounded-full bg-[#366D73] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#3B8C8C] transition-colors duration-200"
              target="_blank"
              rel="noreferrer"
            >
              Contáctanos
            </a>
          </div>
        </nav>
        <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
          <div className="fixed inset-0 z-50 bg-white/80 backdrop-blur-sm" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm shadow-xl">
            <div className="flex items-center justify-between">
              <Link to="/" className="-m-1.5 p-1.5 flex items-center gap-2">
                  <img
                  alt="Adrox"
                  src="/images/adrox_b.png"
                  className="h-8 w-auto"
                />
              </Link>
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="-m-2.5 rounded-md p-2.5 text-[#353E40]"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-100">
                <div className="space-y-1 py-6">
                  {navigation.map((item) => (
                    item.href.startsWith('#') ? (
                      <a
                        key={item.name}
                        href={item.href}
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-medium leading-7 text-[#353E40] hover:bg-gray-50"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        {item.name}
                      </a>
                    ) : (
                      <Link
                        key={item.name}
                        to={item.href}
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-medium leading-7 text-[#353E40] hover:bg-gray-50"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        {item.name}
                      </Link>
                    )
                  ))}
                </div>
                <div className="py-6">
                  <a
                    href="https://wa.me/+51933534235?text=Hola%20estoy%20interesado%20en%20adrox"
                    target="_blank"
                    rel="noreferrer"
                    className="block w-full text-center rounded-full bg-[#366D73] px-4 py-2.5 text-base font-medium text-white hover:bg-[#3B8C8C]"
                  >
                    Contáctanos
                  </a>
                </div>
              </div>
            </div>
          </DialogPanel>
        </Dialog>
      </header>
    </div>
  )
}